<sc-flex vertical fitHeight stretchContent>

    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-basicarticledefinition-editor.title"></sc-dictionary-label>
    </sc-dialog-title>


    <sc-flex-fitting-content vertical>

            <sc-scroll-pane>
                <form [formGroup]="formGroup" class="no-field-space">
                  <sc-padding>
                    <sc-flex stretchContent>

                        <ng-container *ngFor="let group of articleType.attributeGroups">
                          <sc-flex-fitting-content>
                          <div>
                            <div>
                                <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
                            </div>
                            <sc-content-spacer [half]="true"></sc-content-spacer>
                            <ng-container *ngFor="let attribute of group?.attributes">
                                <sc-content-spacer></sc-content-spacer>
                                <mat-checkbox [formControlName]="'attribute_' + attribute.id" class="example-margin">
                                    <app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label>
                                </mat-checkbox>
                            </ng-container>
                            <!-- <sc-content-spacer [double]="true"></sc-content-spacer> -->
                          </div>
                        </sc-flex-fitting-content>
                        </ng-container>
                    </sc-flex>
                  </sc-padding>
                </form>
            </sc-scroll-pane>

    </sc-flex-fitting-content>



    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          <sc-dictionary-label dictionaryKey="erp.ui.articletype-basicarticledefinition-editor.action.cancel"></sc-dictionary-label>
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()">
          <sc-dictionary-label dictionaryKey="erp.ui.articletype-basicarticledefinition-editor.action.confirm"></sc-dictionary-label>
        </button>
    </sc-actionbar>
</sc-flex>
